import "./UserPermissionsComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect, useState} from "react";
import CommonService from "../../../../shared/services/common.service";
import SelectDropdownComponent from "../../../../shared/components/core/select-dropdown/SelectDropdownComponent";
import commonService from "../../../../shared/services/common.service";
import SwitchComponent from "../../../../shared/components/core/switch/switchComponent";
import _ from "lodash";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {Grid} from "@material-ui/core";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {APIConfig, ImageConfig} from "../../../../constants";
import {useSearchParams} from "react-router-dom";
import useFetch from "../../../../shared/hooks/useFetch";

interface UserPermissionsComponentProps {
    userID: any;
    userDetails: any;
    cancel: Function;
    next: Function;
    prev: Function;
}

const UserPermissionsComponent = (props: UserPermissionsComponentProps) => {
    const {userID, cancel, next, prev} = props;
    const [searchParams] = useSearchParams();
    const [isRedirected, setIsRedirected] = useState(false);
    const [roleId, setRoleId] = useState('');

    const [roleDetails, setRoleDetails] = useState<any>({});
    const [initialRoleDetails, setInitialRoleDetails] = useState<any>({});
    const [isRoleDetailsLoading, setIsRoleDetailsLoading] = useState(false);
    const [isRoleDetailsLoaded, setIsRoleDetailsLoaded] = useState(false);
    const [isRoleDetailsLoadingFailed, setIsRoleDetailsLoadingFailed] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {
        response: roleList,
        loading: isRoleListLoading,
        fetchData: fetchRoleList,
    } = useFetch<any>();

    const getRoleDetails = useCallback((roleId: any) => {
        const payload = {};
        setIsRoleDetailsLoading(true);
        setIsRoleDetailsLoaded(false);
        setIsRoleDetailsLoadingFailed(false);
        CommonService._accessLevel.getAccessLevelsOfRole(roleId, payload)
            .then((response: any) => {
                setIsRoleDetailsLoading(false);
                setIsRoleDetailsLoaded(true);
                setIsRoleDetailsLoadingFailed(false);
                setInitialRoleDetails(response?.data);
                const data = response?.data?.map((item: any) => {
                    const features = item?.features?.map((featureItem: any) => {
                        return {...featureItem, isDefault: featureItem.isAccessible}
                    })
                    return {...item, features: features, isDefault: item.isAccessible}
                })
                setRoleDetails(data);
            })
            .catch((error: any) => {
                setIsRoleDetailsLoading(false);
                setIsRoleDetailsLoadingFailed(true);
                setIsRoleDetailsLoaded(false);
                setRoleDetails(undefined)
                commonService._alert.showToast(error?.error, "warning");
            })
    }, []);

    useEffect(() => {
        if (roleId) {
            getRoleDetails(roleId);
        } else {
            setRoleDetails(undefined);
        }
    }, [roleId, getRoleDetails]);

    const handleModuleAccessChange = useCallback((module: string, isAccessible: boolean) => {
        setRoleDetails((prevState: any) => {
            const updatedData = prevState.map((item: any) => {
                if (item.module === module) {
                    if (isAccessible) {
                        const featuseDeselected = item.features.map((featureItem: any) => {
                            return {...featureItem, isAccessible: false}
                        })
                        return {...item, features: featuseDeselected, isAccessible: !item.isAccessible}
                    }
                    return {...item, isAccessible: !item.isAccessible}
                }
                return item;
            })
            return updatedData;
        })
    }, [])

    const handleFeatureAccessChange = useCallback((accessLevelDetails: any, module: string, feature: string) => {
        const data = _.cloneDeep(accessLevelDetails);
        const updatedData = data.map((prevState: any) => {
            if (prevState.module === module) {
                const featureData = prevState.features.map((featureItem: any) => {
                    if (featureItem.feature === feature) {
                        return {...featureItem, isAccessible: !featureItem.isAccessible}
                    }
                    return featureItem;
                })
                return {...prevState, features: featureData}
            }
            return prevState;
        })
        setRoleDetails(updatedData);
    }, [])

    const addUserRole = useCallback(() => {
        setIsSubmitting(true);
        let hybrid = false;
        roleDetails?.forEach((item: any, index: number) => {
            if (item.isAccessible !== initialRoleDetails[index]?.isAccessible) {
                hybrid = true;
            }
            item.features.forEach((feature: any, index: number) => {
                if (feature.isAccessible !== initialRoleDetails[index]?.features[index]?.isAccessible) {
                    hybrid = true;
                }
            })
        })
        const payload = {
            'aclRules': roleDetails,
            'isHybrid': hybrid,
            'isActive': true,
        };
        CommonService._user.adduserRoles(userID, roleId, payload)
            .then((response: any) => {
                setIsSubmitting(false);
                commonService._alert.showToast(response?.message, "success");
                next();
            })
            .catch((error: any) => {
                setIsSubmitting(false);
                commonService._alert.showToast(error?.error, "warning");
            })
    }, [roleDetails, roleId, initialRoleDetails, next, userID]);

    useEffect(() => {
        const permissionType = searchParams.get("permissionType");
        if (permissionType) {
            const preSelectRole = roleList?.find((role: any) => role?.code === permissionType);
            if (preSelectRole) {
                setRoleId(preSelectRole?.id);
                setIsRedirected(true);
            }
        }
    }, [roleList, searchParams]);
    useEffect(() => {
        fetchRoleList({
            url: APIConfig.ROLE_LIST.URL,
            method: APIConfig.ROLE_LIST.METHOD,
            payload: {
                isPhysicianRequired: false
            }
        })
    }, [fetchRoleList])

    return (
        <div className={'user-permissions-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Permissions'}
                tooltipData={"Ensure that the inputs provided are accurate."}
                handleClick={prev}
            />
            <div className="t-form t-form-back-navigation">
                <div className={'no-form'}>
                    <div className="t-form-controls-wrapper">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <SelectDropdownComponent
                                    label={"Select Role"}
                                    id={"role"}
                                    name={"role"}
                                    placeholder={"Search Role Name"}
                                    required={true}
                                    multiple={false}
                                    valueKey={"id"}
                                    onUpdate={(value: any) => {
                                        setRoleId(value)
                                    }}
                                    value={roleId}
                                    options={roleList}
                                    isDataLoading={isRoleListLoading}
                                    getOptionLabel={(option: any) => option?.role}
                                    readOnly={isRedirected}
                                />
                                <div className="add_role_wrapper">
                                    <div>Didn’t find the role?</div>
                                    <a className="create-role-link"
                                       href={CommonService._routeConfig.AccessRoleAddRoute()}
                                       target={'_blank'} rel="noreferrer">Add Role</a>
                                </div>
                            </Grid>

                        </Grid>
                        {
                            isRoleDetailsLoading &&
                            <div className={"glass-effect h-v-center flex-direction-column"}>
                                <LottieFileGenarationComponent
                                    loop={true}
                                    autoplay={true}
                                    animationData={ImageConfig.LoadingLottieFile}/>
                            </div>
                        }
                        {
                            isRoleDetailsLoadingFailed && <StatusCardComponent title={"Failed to load role details"}/>
                        }
                        {
                            isRoleDetailsLoaded && roleDetails && <>
                                <div className={'access-level-details-body-wrapper'}>
                                    <div className={'access-level-details-body-title'}>
                                        Module-wise Permissions
                                    </div>
                                    <div className={'access-level-details-body-description'}>
                                        Ensure that the essential module is activated for the designated user role in
                                        order
                                        to access
                                        its associated features. Once a module is activated, the user can enable these
                                        features
                                        individually.
                                    </div>
                                    <div className={'horizontal-line'}></div>
                                    {
                                        roleDetails?.length > 0 && roleDetails?.map((item: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <div className={'access-level-details-body-module-and-feature-wrapper'}>
                                                        <div className={'access-level-details-body-module-wrapper'}>
                                                            <div
                                                                className={'access-level-details-body-module-title-description-wrapper'}>
                                                                <div className={'access-level-details-body-module-title'}>
                                                                    {item.module}
                                                                </div>
                                                                <div
                                                                    className={'access-level-details-body-module-description'}>
                                                                    {`Access to edit the features of ${item.module}
                                                            module.`}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={'access-level-details-body-module-switch-wrapper'}>
                                                                <SwitchComponent
                                                                    size={"small"}
                                                                    checked={item.isAccessible}
                                                                    readOnly={item.isDefault}
                                                                    disabled={item.isDefault}
                                                                    onUpdate={() => handleModuleAccessChange(item.module, item?.isAccessible)}/>
                                                            </div>
                                                        </div>
                                                        <div className={'access-level-details-body-feature-wrapper'}>
                                                            {
                                                                item.isAccessible && item.features.map((feature: any, index: number) => {
                                                                    let isReadOnly = feature?.isPrimary || feature?.isDefault;
                                                                    if (isReadOnly) {
                                                                        feature.isAccessible = true;
                                                                    }
                                                                    return (
                                                                        <div className={'access-level-details-feature-wrapper'}
                                                                             key={`${feature.feature}-${index}`}>
                                                                            <div
                                                                                className={'access-level-details-body-feature-title-description-wrapper'}
                                                                                key={index}>
                                                                                <div
                                                                                    className={'access-level-details-body-feature-title'}>
                                                                                    {feature.feature}
                                                                                </div>
                                                                                <div
                                                                                    className={'access-level-details-body-feature-description'}>
                                                                                    {feature.description}
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className={'access-level-details-body-feature-switch-wrapper'}>
                                                                                <SwitchComponent
                                                                                    size={"small"}
                                                                                    readOnly={isReadOnly}
                                                                                    disabled={isReadOnly}
                                                                                    checked={feature.isAccessible}
                                                                                    onUpdate={() => handleFeatureAccessChange(roleDetails, item.module, feature?.feature)}/>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={'horizontal-line'}></div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        }
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth={true}
                            disabled={!roleDetails}
                            handleClick={addUserRole}
                            isLoading={isSubmitting}

                        >
                            Submit
                        </ButtonComponent>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default UserPermissionsComponent;
